declare global {
  interface Window {
    analytics: any
    DD_LOGS: any
    rudderanalytics: any
  }
}

export const initializeDatadog = key => {
  if (window.DD_LOGS && key) {
    window.DD_LOGS.init({ clientToken: key, forwardErrorsToLogs: true })
    window.DD_LOGS.addLoggerGlobalContext('service', 'acorns-hello-web')
  }
}

export function initializeAnalytics(token) {
  const analytics = (window.analytics = window.analytics || [])

  if (analytics.initialize) {
    return analytics
  }

  if (analytics.invoked) {
    if (window.console && console.error) {
      console.error('Segment snippet included twice.')
    }
    return
  }

  analytics.invoked = true

  // A list of the methods in Analytics.js to stub.
  analytics.methods = [
    'trackSubmit',
    'trackClick',
    'trackLink',
    'trackForm',
    'pageview',
    'identify',
    'reset',
    'group',
    'track',
    'ready',
    'alias',
    'debug',
    'page',
    'once',
    'off',
    'on',
  ]

  analytics.factory = function(method) {
    return function() {
      // Disabling ESLint for this line for no reason other than the code existed like this before this ESLint rule went into effect.
      // If you're here from the future, please resolve this ESLint error!
      // eslint-disable-next-line prefer-rest-params
      const args = Array.prototype.slice.call(arguments)
      args.unshift(method)
      analytics.push(args)
      return analytics
    }
  }

  for (let i = 0; i < analytics.methods.length; i++) {
    const key = analytics.methods[i]
    analytics[key] = analytics.factory(key)
  }

  analytics.load = function(key, options) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
    const first = document.getElementsByTagName('script')[0]
    first ? first.parentNode.insertBefore(script, first) : document.body.appendChild(script)
    analytics._loadOptions = options
  }

  // Add a version to keep track of what's in the wild.
  analytics.SNIPPET_VERSION = '4.1.0'

  analytics.load(token)
}

export function initializeRudderStackAnalytics(writeKey, dataPlaneUrl) {
  const rudderanalytics = (window.rudderanalytics = window.rudderanalytics || [])

  const methods = [
    'load',
    'page',
    'track',
    'identify',
    'alias',
    'group',
    'ready',
    'reset',
    'getAnonymousId',
    'setAnonymousId',
  ]

  for (let i = 0; i < methods.length; i++) {
    const method = methods[i]
    rudderanalytics[method] = (function(methodName) {
      return function() {
        // Disabling ESLint for this line only because the code existed like this before this ESLint rule went into effect.
        // eslint-disable-next-line prefer-rest-params
        rudderanalytics.push([methodName, ...arguments])
      }
    })(method)
  }

  function loadRudderStackScript() {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = 'https://cdn.rudderlabs.com/rudder-analytics.min.js'
    script.onload = () => {
      //attach window.analytics to loaded window.rudderanalytics
      window.analytics = window.rudderanalytics
    }
    const first = document.getElementsByTagName('script')[0]
    first ? first.parentNode.insertBefore(script, first) : document.body.appendChild(script)
  }

  rudderanalytics.load(writeKey, dataPlaneUrl)
  loadRudderStackScript()

  window.rudderanalytics = rudderanalytics
  window.analytics = window.rudderanalytics
}
